export default __webpack_public_path__ + "guide--vector-tiles-standards-wo-3-480-8da0910e2a795850fec26f405d503224.png";